import React from "react";

export function truncDynCell(
  v: unknown,
  maxWidth?: number | string,
): React.ReactNode {
  const s = v == null ? "" : String(v);
  if (!s) return s;
  return (
    <span
      className="inline-block max-w-full align-middle break-words whitespace-normal"
      style={
        maxWidth == null
          ? undefined
          : {
              maxWidth:
                typeof maxWidth === "number" ? `${maxWidth}px` : maxWidth,
            }
      }
    >
      {s}
    </span>
  );
}
